/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const userDataRoleSchema = z.enum(['member', 'admin', 'jobillan', 'recruiter'])

export type UserDataRoleSchema = z.infer<typeof userDataRoleSchema>
